import type { useOspApiClientProvider } from "@hooks/useOspApiClientProvider";
import { Goal, GoalSortEnum, GoalStatusEnum } from "@features/api/TrackerApi";
import { filterDeletedGoals } from "@/src/hooks/goal/deletedGoals";

type TrackerApiClient = ReturnType<
  typeof useOspApiClientProvider
>["trackerApi"];

/** Plan 诊断候选的状态口径 —— 请求参数与返回复筛共用同一份，避免两边写歪 */
const DIAGNOSIS_STATUSES: GoalStatusEnum[] = [
  GoalStatusEnum.INACTIVE,
  GoalStatusEnum.PLANNED,
];

/** GET /goals page size — backend ListGoalsRequest validates maximum: 20 */
const PLAN_LIST_GOALS_LIMIT = 20;

/** Plan Tab — design §4.8.1 · For You + Checkup 共用（仅真实 API，无 mock 降级） */
export async function fetchPlanDiagnosisGoals(
  trackerApi: TrackerApiClient,
): Promise<Goal[]> {
  return fetchPlanGoals(trackerApi, GoalSortEnum.PRIORITY);
}

export async function fetchPlanPendingGoals(
  trackerApi: TrackerApiClient,
): Promise<Goal[]> {
  return fetchPlanGoals(trackerApi, GoalSortEnum.CREATED);
}

async function fetchPlanGoals(
  trackerApi: TrackerApiClient,
  sort: GoalSortEnum,
): Promise<Goal[]> {
  if (!trackerApi) {
    return [];
  }

  const res = await trackerApi.goals.listGoals({
    status: DIAGNOSIS_STATUSES,
    sort,
    limit: PLAN_LIST_GOALS_LIMIT,
    enrich_hash_data: true,
  });
  const pagination = res.data;
  const rows = pagination?.data?.rows ?? [];
  // 后端会返回 status 与查询条件不符的行（见 fetchGoals.ts 的 filterRowsByStatus 说明），
  // 这里按行里的真实 status 复筛，再剔掉本会话已删的 id。
  return filterDeletedGoals(
    rows.filter(
      (row) => !row.status || DIAGNOSIS_STATUSES.includes(row.status),
    ),
  );
}
